import { User } from "@auth0/auth0-react";
import { AlertProps } from "@mui/material";

export const match4digits = (value: string) => {
  return value === "" || (/^\d+$/.test(value) && value.length <= 4);
};

export const validatePinsMatch = (
  newPin: string,
  newConfirmPin: string,
  setAlert: React.Dispatch<
    React.SetStateAction<{
      severity: AlertProps["severity"];
      message: string;
    } | null>
  >
) => {
  const areFieldsNotEmpty = newPin.length > 0 && newConfirmPin.length > 0;
  let shouldSetError = false;

  if (areFieldsNotEmpty) {
    const minLength = Math.min(newPin.length, newConfirmPin.length);
    const charactersMatch =
      newPin.slice(0, minLength) === newConfirmPin.slice(0, minLength);
    if (!charactersMatch) {
      shouldSetError = true;
    }
  }

  if (shouldSetError) {
    setAlert({ severity: "error", message: "PINs do not match" });
  } else {
    setAlert((prevAlert) =>
      prevAlert?.message.includes("PINs do not match") ? null : prevAlert
    );
  }
};

export const handlePinChange = (
  e: React.ChangeEvent<HTMLInputElement>,
  setPin: (value: string) => void,
  confirmPin: string,
  setAlert: React.Dispatch<
    React.SetStateAction<{
      severity: AlertProps["severity"];
      message: string;
    } | null>
  >
) => {
  const value = e.target.value;
  if (match4digits(e.target.value)) {
    setPin(value);
    validatePinsMatch(value, confirmPin, setAlert);
  }
};

export const handleConfirmPinChange = (
  e: React.ChangeEvent<HTMLInputElement>,
  setConfirmPin: (value: string) => void,
  pin: string,
  setAlert: React.Dispatch<
    React.SetStateAction<{
      severity: AlertProps["severity"];
      message: string;
    } | null>
  >
) => {
  const value = e.target.value;

  if (match4digits(value)) {
    setConfirmPin(value);
    validatePinsMatch(pin, value, setAlert);
  }
};

export const hasPin = (user: User): boolean =>
  "ecfrPin" in user && user.ecfrPin?.updatedAt !== undefined;

export const setupPinWarningText =
  "Please securely save your pin and do not share it with others. You may reset your pin later if necessary.";
